<template lang="pug">
  v-row.my-4(no-gutters)
    v-col.shrink.pr-4
      v-img(:src="(productObj && productObj.image) ? `https://img.yezza.io/120x120/${productObj.image.path}` : require('@/assets/image_placeholder.png')" max-width="48px" width="48px" height="48px")
    v-col.pr-2(cols="6")
      //- PARENT NAME
      div.p2.primary--text {{ productName(product) }}
      //- VARIANT NAME
      template(v-if="product.product.variant_for && isSameParentVariantName(product)")
        div.c1.basic600--text {{ product.product.name }}
      //- ADDON LIST
      template(v-if="product.addons.length > 0")
        div(v-for="(addon, idx) in product.addons" :key="'addon-' + idx")
          div.c1.basic600--text(:key="addon.id") + {{ addon.name }}{{ addon.quantity_per_set > 1 ? ' x ' + addon.quantity_per_set : '' }}
      //- BUNDLE LIST
      template(v-if="product.bundles.length > 0")
        div(v-for="(bundle, bundleIndex) in product.bundles" :key="'bundle-' + bundleIndex")
          div.c1.basic600--text.mt-1 {{ bundleIndex + 1 }}. {{ bundle.name }}
          //- BUNDLE PRODUCT NOTES
          div(v-if="bundle.product_notes_data && bundle.product_notes_data.length > 0")
            div(v-for="note in bundle.product_notes_data" :key="note.id")
              div.c1.primary400--text.ml-2 - 
                strong {{ note.name }}: 
                | {{ note.data }}
      //- PRODUCT NOTES
      div.mt-1(v-if="product.product_notes_data && product.product_notes_data.length > 0")
        div(v-for="note in product.product_notes_data" :key="note.id")
          div.c1.primary400--text
            strong {{ note.name }}: 
            | {{ note.data }}
    v-col(cols="1")
      div.p2.primary--text {{ product.quantity }}
    v-col(align="right")
      div.p2.primary--text {{ product.price_per_set * product.quantity | displayPrice }}
</template>

<script>
export default {
  name: 'OrderItemProduct',
  props: ['product'],
  data: () => ({
    productObj: null
  }),
  mounted() {
    this.fetchProduct()
  },
  methods: {
    isSameParentVariantName(product) {
      return product.name.includes(`(${product.product.name})`)
    },
    productName(product) {
      if (product.product.variant_for) {
        if (this.isSameParentVariantName(product)) {
          return product.name.replace(`(${product.product.name})`, '')
        }
      }
      return product.name
    },
    fetchProduct() {
      this.$axios
        .get(`/products/${this.product.product.id}`)
        .then(resp => {
          this.productObj = resp.data
          // Get parent image if no image and product is variant type
          if (!this.productObj.image && this.productObj.variant_for) {
            this.getRelatedImage(this.productObj)
          }
        })
        .catch(() => {})
    },
    getRelatedImage(product) {
      // Get image of the parent of the product variant
      this.$axios
        .get(`/products/${product.variant_for}`)
        .then(resp => {
          product.image = resp.data.image
        })
        .catch(() => {})
    }
  }
}
</script>